import React from 'react'

export const BigTableData = (): { metadata: any; data: any[] } => {
  const data = React.useMemo(
    () =>
      Array.from({ length: 50 }, (_, index) => ({
        alertLabel: 'high',
        hash: `${index + 1}`,
        id: `${12345 + index}`,
        alertName:
          'The application powershell.exe is executing a fileless script or command.',
        createdDate: '2021-05-18T09:41:31.273Z',
        lastUpdateDate: '2021-05-18T09:41:31.273Z',
        severity: 'High',
        status: 'Pending',
        category: 'Monitored',
        service: 'End Point Security',
        caseOwner: 'Team1',
        subComponent: [
          {
            title: 'Alerts',
            fields: [
              {
                name: 'Category',
                value: `${12345 + index}`,
              },
            ],
          },
          {
            title: 'Severity',
            fields: [
              {
                name: 'Level',
                value: `${12345 + index}`,
              },
            ],
          },
        ],
      })),
    []
  )

  const columns = React.useMemo(
    () => [
      {
        Header: '#',
        accessor: 'hash',
      },
      {
        Header: 'ID',
        accessor: 'id',
        filterType: 'checkbox',
      },
      {
        Header: 'Alert name/Description',
        accessor: 'alertName',
        filterType: 'checkbox',
      },
      {
        Header: 'Created Date',
        accessor: 'createdDate',
        filterType: 'dateRange',
      },
      {
        Header: 'Last Update Date',
        accessor: 'lastUpdateDate',
      },
      {
        Header: 'Severity',
        accessor: 'severity',
        filterType: 'checkbox',
      },
      {
        Header: 'Status',
        accessor: 'status',
        filter: 'status',
      },
      {
        Header: 'Category',
        accessor: 'category',
      },
      {
        Header: 'Service',
        accessor: 'service',
      },
      {
        Header: 'Case Owner',
        accessor: 'caseOwner',
      },
    ],
    []
  )

  return { metadata: { columns }, data }
}
